import {
  get
} from './request.js'

export const linkApi = params =>
  get('/v1.0.0/front/item/detail', params)
export const getCesMoimgs = params =>
  get('/v1.0.0/front/item/detail', params)
